import { render, staticRenderFns } from "./banner.vue?vue&type=template&id=10e08c7f&scoped=true"
import script from "./banner.vue?vue&type=script&lang=js"
export * from "./banner.vue?vue&type=script&lang=js"
import style0 from "./banner.vue?vue&type=style&index=0&id=10e08c7f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e08c7f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/private/workspaces/smart-life/smart-life-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10e08c7f')) {
      api.createRecord('10e08c7f', component.options)
    } else {
      api.reload('10e08c7f', component.options)
    }
    module.hot.accept("./banner.vue?vue&type=template&id=10e08c7f&scoped=true", function () {
      api.rerender('10e08c7f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/article/banner.vue"
export default component.exports